import { useLanguage } from '@context/LanguageContext'
import { useNavigate } from 'react-router-dom'
import { useDocumentMetadata } from '@hooks/useDocumentMetadata'
import { useNamespaces } from '@hooks/useNamespaces'
import { ROUTE_NAMESPACES } from '@i18n/namespaces'
import ScreenFallback from '@components/layout/ScreenFallback'
import styles from './NotFound.module.css'

export default function NotFound () {
  const { t } = useLanguage()
  const navigate = useNavigate()
  const { isLoading: namespacesLoading } = useNamespaces(ROUTE_NAMESPACES.notFound)
  useDocumentMetadata()

  if (namespacesLoading) {
    return <ScreenFallback />
  }

  return (
    <main className={styles.notFound} aria-labelledby='notfound-title'>
      <div className={styles.header}>
        <h1 id='notfound-title' className={styles.code}>{t.notFound.title}</h1>
        <p className={styles.message}>{t.notFound.message}</p>
      </div>
      <img
        src='/cards/fallback.webp'
        alt=''
        className={styles.image}
        aria-hidden='true'
        loading='lazy'
        decoding='async'
      />
      <button
        onClick={() => navigate('/')}
        className={styles.btn}
      >
        {t.notFound.button}
      </button>
    </main>
  )
}
